import sessionReducer from './SessionReducer';
import orderReducer from './OrderReducer';
import editDishReducer from './EditDishReducer';
import CheckoutReducer from './CheckoutReducer';
import CashierReducer from './CashierReducer';

export default {
  session: sessionReducer,
  order: orderReducer,
  editDish: editDishReducer,
  checkout: CheckoutReducer,
  cashier: CashierReducer,
};
